// Contenido central del sitio COLLECTIVE CO LIVING
import {
  Wifi,
  Briefcase,
  DoorClosed,
  CookingPot,
  Sun,
  Sparkles,
  ShieldCheck,
  Droplets,
} from "lucide-react";
import logoNavy from "../assets/logo-navy.png";
import logoWhite from "../assets/logo-white.png";

export const BRAND = {
  name: "COLLECTIVE CO LIVING",
  managedBy: "IBL Venture Capital",
  whatsapp: "528911317346",
  whatsappDisplay: "+52 891 131 7346",
  whatsappUrl: "https://wa.me/528911317346",
  email: "arrendamiento@iblvc.com",
  instagram: "@remodify.mx",
  instagramUrl: "https://instagram.com/remodify.mx",
  // Instagram oculto temporalmente del sitio público (sin eliminar el código).
  showInstagram: false,
  address: "Carretera Picacho Ajusco MZ 21 LT 77",
};

export const LOGO_URL = logoNavy;
export const LOGO_URL_WHITE = logoWhite;

// IMÁGENES TEMPORALES (placeholders lifestyle). Reemplazar por fotografías reales.
export const IMAGES = {
  hero: "https://customer-assets.emergentagent.com/job_premium-coliving/artifacts/wehwcwdb_3.jpeg",
  community:
    "https://images.unsplash.com/photo-1582298538104-fe2e74c27f59?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  kitchen:
    "https://images.pexels.com/photos/3758045/pexels-photo-3758045.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
  room:
    "https://images.unsplash.com/photo-1644955052489-10bda5c94b19?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  room2:
    "https://images.unsplash.com/photo-1657040899601-fbcc8f6486f6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  terrace:
    "https://images.pexels.com/photos/5935187/pexels-photo-5935187.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
  coworking:
    "https://images.unsplash.com/photo-1519671282429-b44660ead0a7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const NAV_LINKS = [
  { id: "inicio", label: "Inicio" },
  { id: "amenidades", label: "Amenidades" },
  { id: "habitaciones", label: "Habitaciones" },
  { id: "galeria", label: "Galería" },
  { id: "recorrido", label: "Recorrido" },
  { id: "ubicacion", label: "Ubicación" },
  { id: "requisitos", label: "Requisitos" },
  { id: "reglamento", label: "Reglamento" },
  { id: "faq", label: "FAQ" },
];

export const WHY_CHOOSE = [
  {
    number: "01",
    title: "Una comunidad real",
    text: "Más que un cuarto: vecinos con quienes compartir cocina, terraza y planes. Vive cerca de gente que también busca crecer.",
  },
  {
    number: "02",
    title: "Listo para mudarte hoy",
    text: "Habitaciones totalmente amuebladas con servicios incluidos. Llega con tus maletas y empieza a vivir desde el primer día.",
  },
  {
    number: "03",
    title: "Trabaja sin salir de casa",
    text: "Coworking, salas privadas e internet incluido para que tu día fluya entre el trabajo y el descanso.",
  },
  {
    number: "04",
    title: "Tranquilidad incluida",
    text: "Vigilancia 24/7, mantenimiento constante y administración profesional que cuida cada detalle.",
  },
];

export const AMENITIES = [
  { icon: Wifi, title: "Internet incluido", text: "Conectividad estable en todo el inmueble." },
  { icon: Briefcase, title: "Coworking", text: "Espacios de trabajo equipados y silenciosos." },
  { icon: DoorClosed, title: "Salas privadas", text: "Privacidad para reuniones y videollamadas." },
  { icon: CookingPot, title: "Cocina compartida", text: "Equipada y mantenida para uso diario." },
  { icon: Sun, title: "Terrazas", text: "Áreas al aire libre para convivir y descansar." },
  { icon: Sparkles, title: "Limpieza de áreas comunes", text: "Mantenimiento profesional constante." },
  { icon: ShieldCheck, title: "Vigilancia 24/7", text: "Seguridad continua durante todo el día." },
  { icon: Droplets, title: "Servicios incluidos", text: "Agua, luz y gas dentro de tu renta." },
];

// HABITACIONES (datos vienen del backend; este arreglo es respaldo).
export const ROOMS = [];

export const GALLERY = [
  { src: "community", alt: "Conviviendo en comunidad", span: "lg:col-span-2 lg:row-span-2" },
  { src: "room", alt: "Habitación amueblada", span: "" },
  { src: "kitchen", alt: "Cocina compartida", span: "" },
  { src: "terrace", alt: "Terraza social", span: "lg:row-span-2" },
  { src: "coworking", alt: "Área de coworking", span: "lg:col-span-2" },
  { src: "room2", alt: "Espacio para descansar", span: "" },
];

export const NEARBY = [
  "Parque CDMX",
  "Ajusco (Totolapan, Xitle, Pico del Águila)",
  "Escuelas (kinder, primaria, secundaria, prepa)",
  "Cablebús (próximamente)",
];

// Requisitos como 5 pasos amigables.
export const REQUIREMENTS = [
  {
    step: "01",
    title: "Agenda tu visita",
    text: "Escríbenos por WhatsApp o el formulario y coordina un recorrido por el inmueble.",
  },
  {
    step: "02",
    title: "Conoce tu espacio",
    text: "Visita las áreas comunes y elige la habitación que mejor se adapte a ti.",
  },
  {
    step: "03",
    title: "Envía tus documentos",
    text: "Identificación oficial, comprobante de domicilio y un comprobante de ingresos.",
  },
  {
    step: "04",
    title: "Validación exprés",
    text: "Revisamos tu solicitud rápidamente y te confirmamos la disponibilidad.",
  },
  {
    step: "05",
    title: "Firma y múdate",
    text: "Firma tu contrato, cubre el depósito y el primer mes, ¡y bienvenido a casa!",
  },
];

export const RULES = [
  { category: "Cocina", text: "La cocina es de uso compartido. Lava y guarda tus utensilios inmediatamente después de usarlos y mantén limpias las superficies, la estufa y el fregadero. Los alimentos deben etiquetarse y almacenarse en los espacios asignados del refrigerador." },
  { category: "Coworking", text: "El área de coworking está destinada al trabajo y al estudio. Mantén un ambiente de silencio y respeto; realiza llamadas y videollamadas en las salas privadas. Cuida el mobiliario y deja tu lugar limpio al retirarte." },
  { category: "Salas privadas", text: "Las salas privadas pueden utilizarse para reuniones, llamadas o videollamadas por tiempo determinado. Respeta los horarios reservados por otros residentes y entrega la sala limpia y ordenada." },
  { category: "Terrazas", text: "Las terrazas son espacios de convivencia y descanso. Respeta los horarios establecidos para evitar ruido excesivo, especialmente por la noche. Recoge tus pertenencias y residuos." },
  { category: "Baños", text: "Los baños compartidos deben dejarse limpios y secos después de cada uso. Cuida el consumo de agua y reporta cualquier desperfecto a la administración a la brevedad." },
  { category: "Visitas", text: "Las visitas deben registrarse previamente con la administración y respetar los horarios establecidos. El residente es responsable de la conducta de sus visitantes." },
  { category: "Convivencia", text: "Fomentamos un ambiente de respeto y tolerancia. Mantén niveles de ruido moderados y respeta los espacios y pertenencias de los demás." },
  { category: "Sanciones", text: "El incumplimiento del reglamento podrá dar lugar a llamadas de atención, sanciones económicas o, en casos graves, la rescisión del contrato conforme a lo establecido en el mismo." },
];

export const FAQ = [
  {
    q: "¿Cuál es la estancia mínima?",
    a: "La estancia mínima es de 2 meses. Después podrás renovar tu estancia según disponibilidad.",
  },
  {
    q: "¿Qué servicios están incluidos en la renta?",
    a: "Todo lo esencial para que solo te preocupes por vivir:",
    bullets: [
      "Internet incluido",
      "Servicio de agua",
      "Servicio de gas",
      "Energía eléctrica",
      "Vigilancia 24/7",
      "Terrazas de uso común",
      "Salas de trabajo",
      "Coworking",
      "Baños compartidos",
      "2 cocinas compartidas",
      "Limpieza de áreas comunes",
    ],
  },
  {
    q: "¿Las habitaciones están amuebladas?",
    a: "Sí. Todas se entregan completamente amuebladas y listas para habitarse. Incluyen:",
    bullets: ["Base y cabecera", "Colchón", "Buró", "Frigobar", "Clóset", "Juego de sábanas", "Colcha", "Almohadas"],
  },
  {
    q: "¿Pueden vivir niños en COLLECTIVE CO LIVING?",
    a: "Sí, según la habitación y su capacidad. Algunas habitaciones son ideales para un adulto con un niño. Cuéntanos tu caso al agendar tu visita y te orientamos sobre las opciones disponibles.",
  },
  {
    q: "¿Cuántas personas pueden habitar una habitación?",
    a: "Depende del tamaño de la habitación. La mayoría están pensadas para 1 o 2 personas. En el formulario puedes indicar cuántas personas serán y te confirmamos la mejor opción.",
  },
  {
    q: "¿Puedo recibir visitas?",
    a: "Sí. Las visitas son bienvenidas registrándolas previamente con la administración y respetando los horarios y la convivencia de la comunidad. La pernocta de visitas requiere autorización.",
  },
  {
    q: "¿Cómo aparto una habitación?",
    a: "Agenda una visita por WhatsApp o el formulario. Tras conocer el inmueble, envía tu documentación para validación; una vez aprobada y firmado el contrato, se asigna tu habitación.",
  },
  {
    q: "¿Se solicita depósito?",
    a: "Sí, un depósito equivalente a un mes de renta, reembolsable al finalizar el contrato conforme a las condiciones establecidas.",
  },
  {
    q: "¿Se aceptan mascotas?",
    a: "Únicamente se permiten animales de asistencia o servicio debidamente acreditados con documentación oficial vigente.",
  },
];
